import { createTheme } from "@mui/material";

export const theme = createTheme(
    {
        palette: {
            mode: "dark",
            primary: {
                main: "#fff149"
            }
        }, 
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        borderRadius: 20
                    }
                }
            }
        },
        typography: {
            button: {
                fontSize: "1rem"
            }
        }
    }
);